module.exports = __webpack_public_path__ + "img/lg_ring_r_i_null_null@2x.ae433f6e.png";